import * as yup from 'yup';

// src/helpers/validationSchemas/menu/reportingGroupSchema.ts
var reportingGroupSchema = yup.object().shape({
  name: yup.string().trim().required("nameRequired")
});

export { reportingGroupSchema };
